var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", { attrs: { title: _vm.$t("projects.title") } }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c(
            "div",
            {
              staticClass:
                "cell medium-9 medium-offset-1 large-11 large-offset-0",
            },
            [
              _c("v-action-buttons", {
                attrs: { items: _vm.getActionButtons },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c("div", { staticClass: "grid-x" }, [
                    _c("div", { staticClass: "cell small-12 medium-3" }, [
                      _c("h2", [_vm._v(_vm._s(_vm.$t("projects.title")))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell small-12 medium-9" }, [
                      _c(
                        "div",
                        { staticClass: "projects-qm-count" },
                        [
                          _vm.isCalculatingTotalQm
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "loading-spinner-wrapper" },
                                  [
                                    _c("PageLoading", {
                                      attrs: {
                                        position: "absolute",
                                        right: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c("ul", [
                                  _c(
                                    "li",
                                    [
                                      _vm.projectsTableItemsCount === 1
                                        ? [
                                            _vm._v(
                                              _vm._s(_vm.$t("project.title")) +
                                                ":"
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              _vm._s(_vm.$t("projects.title")) +
                                                ":"
                                            ),
                                          ],
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$helpers.formatNumber(
                                              _vm.projectsTableItemsCount
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("projects.qm.total")) +
                                        "\n                      "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$helpers.formatNumber(
                                            _vm.projectsTotalQm
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("qm")) +
                                        "\n                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t("projects.qm.totalopen")
                                        ) +
                                        "\n                      "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$helpers.formatNumber(
                                            _vm.projectsTotalOpenQm
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("qm")) +
                                        "\n                    "
                                    ),
                                  ]),
                                ]),
                              ],
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "filter filter--search",
                      attrs: { action: "", method: "POST", novalidation: "" },
                      on: { submit: _vm.onChangeProjectsTableFilter },
                    },
                    [
                      _vm.$store.getters.userIsAdmin
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "grid-x grid-padding-x align-middle align-right u-extra-small-margin--bottom",
                            },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cell small-auto medium-3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group form-group--row u-no-margin--bottom",
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "u-no-margin--bottom text-right",
                                          attrs: { for: "form-field-minqm" },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("search.from"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.projectsTableFilter.minqm,
                                            expression:
                                              "projectsTableFilter.minqm",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control--small u-no-margin--bottom",
                                        attrs: {
                                          type: "number",
                                          inputmode: "decimal",
                                          id: "form-field-minqm",
                                          name: "minqm",
                                          placeholder: _vm.$t("search.from"),
                                        },
                                        domProps: {
                                          value: _vm.projectsTableFilter.minqm,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.projectsTableFilter,
                                              "minqm",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "u-no-margin--bottom text-right",
                                          attrs: { for: "form-field-maxqm" },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("search.till")))]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.projectsTableFilter.maxqm,
                                            expression:
                                              "projectsTableFilter.maxqm",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control--small u-no-margin--bottom",
                                        attrs: {
                                          type: "number",
                                          inputmode: "decimal",
                                          id: "form-field-maxqm",
                                          name: "maxqm",
                                          placeholder: _vm.$t("search.till"),
                                        },
                                        domProps: {
                                          value: _vm.projectsTableFilter.maxqm,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.projectsTableFilter,
                                              "maxqm",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter__grid" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("v-select-location", {
                                  attrs: {
                                    placeholder: _vm.$t("search.location"),
                                  },
                                  model: {
                                    value: _vm.projectsTableFilter.location_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.projectsTableFilter,
                                        "location_id",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "projectsTableFilter.location_id",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("v-select-user", {
                                  attrs: {
                                    placeholder: _vm.$t("search.pm"),
                                    userType: _vm.$helpers.usertypes.pm,
                                  },
                                  model: {
                                    value: _vm.projectsTableFilter.account_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.projectsTableFilter,
                                        "account_id",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "projectsTableFilter.account_id",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("v-datepicker", {
                                  staticClass:
                                    "form-control form-control--small form-control--date",
                                  attrs: {
                                    placeholder: _vm.$t("search.from"),
                                    format:
                                      _vm.$t("search.from") +
                                      " " +
                                      _vm.$helpers.dateFormat,
                                    disabledDates: {
                                      days: [6, 0],
                                      from: new Date(
                                        _vm.projectsTableFilter.till
                                      ),
                                    },
                                    clearButton: true,
                                    language: _vm.de,
                                    "monday-first": true,
                                  },
                                  model: {
                                    value: _vm.projectsTableFilter.from,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.projectsTableFilter,
                                        "from",
                                        $$v
                                      )
                                    },
                                    expression: "projectsTableFilter.from",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("v-datepicker", {
                                  staticClass:
                                    "form-control form-control--small form-control--date",
                                  attrs: {
                                    placeholder: _vm.$t("search.till"),
                                    format:
                                      _vm.$t("search.till") +
                                      " " +
                                      _vm.$helpers.dateFormat,
                                    disabledDates: {
                                      days: [6, 0],
                                      to: new Date(
                                        _vm.projectsTableFilter.from
                                      ),
                                    },
                                    clearButton: true,
                                    language: _vm.de,
                                    "monday-first": true,
                                  },
                                  model: {
                                    value: _vm.projectsTableFilter.till,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.projectsTableFilter,
                                        "till",
                                        $$v
                                      )
                                    },
                                    expression: "projectsTableFilter.till",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("v-select-status", {
                                  staticClass: "form-control--small",
                                  attrs: {
                                    placeholder: _vm.$t("search.status"),
                                    prependedOptions:
                                      _vm.prependedStatusOptions,
                                  },
                                  model: {
                                    value: _vm.projectsTableFilter.status,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.projectsTableFilter,
                                        "status",
                                        $$v
                                      )
                                    },
                                    expression: "projectsTableFilter.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--large",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-group form-group--row u-no-margin--bottom",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--search",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.projectsTableFilter.search,
                                          expression:
                                            "projectsTableFilter.search",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control--small form-control--search",
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t("search.term"),
                                      },
                                      domProps: {
                                        value: _vm.projectsTableFilter.search,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.projectsTableFilter,
                                            "search",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        attrs: {
                                          role: "button",
                                          type: "submit",
                                          title: _vm.$t("search"),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.$t("search")) +
                                            "\n                              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-table", {
                    attrs: {
                      isLoading: _vm.projectsTableLoading,
                      columns: _vm.projectsTableColumns,
                      items: _vm.projectsTableItems,
                      showShowAll: false,
                      useDetailRow: true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "deadline",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "table-date" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("moment")(row.createdon.date, "DD")
                                    ) +
                                    "\n                "
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("moment")(
                                        row.createdon.date,
                                        "MMM"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.$store.getters.userIsAdmin
                                ? [
                                    !row.lat || !row.lon
                                      ? _c(
                                          "div",
                                          {
                                            attrs: {
                                              title: _vm.$t(
                                                "project.error.nogeolocation"
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "u-icon--geolocation-warning",
                                                attrs: { role: "presentation" },
                                              },
                                              [
                                                _c("use", {
                                                  attrs: {
                                                    "xlink:href":
                                                      "/dist/sprite.svg#icon-globe",
                                                    href: "/dist/sprite.svg#icon-globe",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "address",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "table-label" }, [
                                _vm._v(_vm._s(row.project_number)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "table-description" }, [
                                _vm._v(
                                  _vm._s(row.address.zipcode) +
                                    " " +
                                    _vm._s(row.address.city) +
                                    ",\n                " +
                                    _vm._s(row.address.street) +
                                    " " +
                                    _vm._s(row.address.housenumber)
                                ),
                              ]),
                              _vm._v(" "),
                              row.earliest_start
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-description table-description--normal",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "form.project.earliest_start"
                                            )
                                          ) +
                                          ":\n                " +
                                          _vm._s(
                                            _vm.$helpers.formatEarliestStartLabel(
                                              row.earliest_start
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !row.earliest_start_comment &&
                              row.requested_deadline
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-description table-description--normal",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "form.project.requested_deadline"
                                            )
                                          ) +
                                          ":\n                " +
                                          _vm._s(row.requested_deadline) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              row.tour_routes
                                ? _vm._l(
                                    row.tour_routes,
                                    function (route, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index + "_tour-routes",
                                          staticStyle: {
                                            "white-space": "nowrap",
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "u-icon--announcement",
                                              attrs: { role: "presentation" },
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "/dist/sprite.svg#icon-announcement",
                                                  href: "/dist/sprite.svg#icon-announcement",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("small", [
                                            _c("strong", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("tours.expecteddate")
                                                  ) +
                                                  "\n                      " +
                                                  _vm._s(_vm.$t("tours.from")) +
                                                  "\n                      " +
                                                  _vm._s(
                                                    _vm._f("moment")(
                                                      route.tour_startdate,
                                                      "DD.MM.YYYY"
                                                    )
                                                  ) +
                                                  "\n                      " +
                                                  _vm._s(_vm.$t("tours.till")) +
                                                  "\n                      " +
                                                  _vm._s(
                                                    _vm._f("moment")(
                                                      route.tour_enddate,
                                                      "DD.MM.YYYY"
                                                    )
                                                  ) +
                                                  "\n                      | Kol. " +
                                                  _vm._s(route.kolonne) +
                                                  "\n                    "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              row.weekplan_entries
                                ? _vm._l(
                                    row.weekplan_entries,
                                    function (entry, index) {
                                      return _c(
                                        "div",
                                        { key: index + "weekplan-entries" },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "u-icon--announcement",
                                              attrs: { role: "presentation" },
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "/dist/sprite.svg#icon-announcement",
                                                  href: "/dist/sprite.svg#icon-announcement",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("small", [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("tours.expecteddate")
                                                ) +
                                                  "\n                      " +
                                                  _vm._s(
                                                    _vm._f("moment")(
                                                      entry.startdate,
                                                      "DD.MM.YYYY"
                                                    )
                                                  ) +
                                                  "\n                       | Kol. " +
                                                  _vm._s(entry.kolonne) +
                                                  "\n                      "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "location",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "table-label" }, [
                                _vm._v(_vm._s(row.location.company_name)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "table-description" }, [
                                _vm._v(_vm._s(_vm.$t("form.project.location"))),
                              ]),
                              _vm._v(" "),
                              _vm.$store.getters.userIsAdmin
                                ? [
                                    row.location.risk
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "table-description table-description--normal",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "location.risk.risk_number"
                                                    )
                                                  ) +
                                                  ": " +
                                                  _vm._s(
                                                    row.location.risk
                                                      .risk_number
                                                  )
                                              ),
                                              row.location.risk.decided_budget
                                                ? [
                                                    _vm._v(
                                                      ", " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "location.risk.limit"
                                                          )
                                                        ) +
                                                        ": " +
                                                        _vm._s(
                                                          _vm.$helpers.formateCurrency(
                                                            row.location.risk
                                                              .decided_budget
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          !row.location.risk.decided_budget
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "u-color--alert table-description",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "location.risk.decided_budget.not_exist"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !row.location.risk.is_valid
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "u-color--alert table-description",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "location.risk.not_valid"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "table-description u-color--alert",
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "location.risk.no_risk_number"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "project_manager",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "table-label" }, [
                                _vm._v(
                                  _vm._s(row.account.profile.firstname) +
                                    "\n                " +
                                    _vm._s(row.account.profile.lastname)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "table-description" }, [
                                _vm._v(_vm._s(_vm.$t("form.project.pm"))),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "qm",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "table-status table-status--right",
                                },
                                [
                                  _vm.$store.getters.userHasPermission(
                                    "project_update_status"
                                  )
                                    ? [
                                        ["open", "pending"].indexOf(
                                          row.status
                                        ) !== -1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "status-icon",
                                                class:
                                                  "status-icon--" + row.status,
                                                attrs: {
                                                  role: "button",
                                                  title: _vm.$t(
                                                    "status." +
                                                      row.status +
                                                      "_short"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "status." +
                                                          row.status +
                                                          "_short"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass: "status-icon",
                                                class:
                                                  "status-icon--" + row.status,
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status." +
                                                        row.status +
                                                        "_short"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    : [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "status-icon",
                                            class: "status-icon--" + row.status,
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "status." +
                                                    row.status +
                                                    "_short"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                  _vm._v(" "),
                                  _c("span", { staticClass: "table-label" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$helpers.formatNumber(
                                            row.stats.qm.open
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "u-text-small u-text-normal",
                                      },
                                      [
                                        _vm._v(
                                          "/ " +
                                            _vm._s(
                                              _vm.$helpers.formatNumber(
                                                row.stats.qm.total
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "table-description" },
                                    [_vm._v(_vm._s(_vm.$t("qm")))]
                                  ),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                        {
                          key: "status",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "table-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("status." + row.status + "_short")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "table-description" }, [
                                _vm._v(_vm._s(_vm.$t("status"))),
                              ]),
                              _vm._v(" "),
                              row.status == "cancelled"
                                ? [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            row.modifiedon.date,
                                            _vm.$helpers.dateFormat.toUpperCase()
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "media",
                          fn: function ({ row }) {
                            return [
                              _vm.$store.getters.userHasPermission(
                                "project_media_list"
                              )
                                ? [
                                    row.uploads.length >= 1
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "button button--action button--action--files button--small",
                                            attrs: {
                                              to: {
                                                name: "customers-view-customer-project-media",
                                                params: {
                                                  customer: row.customer_id,
                                                  project: row.id,
                                                },
                                              },
                                              title: _vm.$t("media"),
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("media")))]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "duplicate",
                          fn: function ({ row }) {
                            return [
                              _vm.$store.getters.userHasPermission(
                                "project_create"
                              )
                                ? [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "button button--action button--action--duplicate button--small",
                                        attrs: {
                                          to: {
                                            name: "customers-duplicate-customer-project",
                                            params: {
                                              customer: row.customer_id,
                                              project: row.id,
                                            },
                                          },
                                          title: _vm.$t("duplicate"),
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("duplicate")))]
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "update",
                          fn: function ({ row }) {
                            return [
                              _vm.$store.getters.userHasPermission(
                                "project_update"
                              )
                                ? [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "button button--action button--action--edit button--small",
                                        attrs: {
                                          to: {
                                            name: "customers-update-customer-project",
                                            params: {
                                              customer: row.customer_id,
                                              project: row.id,
                                            },
                                          },
                                          title: _vm.$t("update"),
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("update")))]
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                        _vm.$store.getters.userIsAdmin
                          ? {
                              key: "pdf",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button button--action button--action--pdf button--small",
                                      attrs: {
                                        type: "button",
                                        value: row.project_number,
                                        title: _vm.$t("generatepdf"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generateProjectPdf(
                                            row.id,
                                            row.project_number
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("generatepdf")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            }
                          : null,
                        {
                          key: "detail-row",
                          fn: function ({ row }) {
                            return [
                              _c("v-projects-table-detail-row", {
                                on: { update: _vm.onChangeProjectObject },
                                model: {
                                  value: row,
                                  callback: function ($$v) {
                                    row = $$v
                                  },
                                  expression: "row",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("v-pagination", {
                    attrs: {
                      currentPage: _vm.projectsTableCurrentPage,
                      itemsPerPage: _vm.projectsTableItemsPerPage,
                      items: _vm.projectsTableItemsCount,
                    },
                    on: { pageClicked: _vm.onChangeProjectsTablePage },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-pdf-dialog", {
                attrs: {
                  isVisible: _vm.pdfDialogIsVisible,
                  projectId: _vm.pdfProjectId,
                  projectNumber: _vm.pdfProjectNumber,
                },
                model: {
                  value: _vm.pdfDialogIsVisible,
                  callback: function ($$v) {
                    _vm.pdfDialogIsVisible = $$v
                  },
                  expression: "pdfDialogIsVisible",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cell small-auto medium-9 u-no-padding" }, [
      _c("p", { staticClass: "u-no-margin hide-for-medium" }, [
        _c("strong", [_vm._v("Offene QM:")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "u-no-margin text-right show-for-medium" }, [
        _c("strong", [_vm._v("Offene QM:")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }